// export function loadRexWidgetScript({
//   agentId = "agent_0498e1599d6ea9e13d09657f79",
//   defer = true,
// } = {}) {
//   if (document.getElementById("rex-widget-script")) {
//     return Promise.resolve(window.REX || null);
//   }
//   window.__REX_DEFER_SHOW__ = !!defer;
//   document.body.classList.add("rex-defer");

//   return new Promise((resolve, reject) => {
//     const s = document.createElement("script");
//     s.id = "rex-widget-script";
//     s.src = `https://rexpt-chat-widget.vercel.app/index.js?agentId=${encodeURIComponent(
//       agentId
//     )}`;
//     s.async = true;
//     s.defer = true;
//     s.crossOrigin = "anonymous";
//     s.onload = () => {
//       document.body.classList.remove("rex-defer");
//       resolve(window.REX || null);
//     };
//     s.onerror = (e) => {
//       console.error("[REX] script load failed", e);
//       document.body.classList.remove("rex-defer");
//       reject(e);
//     };
//     document.body.appendChild(s);
//   });
// }
export function loadRexWidgetScript({
  agentId = "agent_0498e1599d6ea9e13d09657f79",
  defer = true,
  widgetUrl = "https://rexpt-chat-widget.vercel.app/index.js",
} = {}) {
  const existing = document.getElementById("rex-widget-script");
  if (existing && existing.src.startsWith(widgetUrl)) {
    return Promise.resolve(window.REX || null);
  }
  if (existing && !existing.src.startsWith(widgetUrl)) {
    existing.remove();
  }

  window.__REX_DEFER_SHOW__ = !!defer;
  document.body.classList.add("rex-defer");

  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.id = "rex-widget-script";
    s.src = `${widgetUrl}?agentId=${encodeURIComponent(agentId)}`;
    s.async = true;
    s.defer = true;
    s.crossOrigin = "anonymous";

    s.onload = () => {
      document.body.classList.remove("rex-defer");
      resolve(window.REX || null);
    };

    s.onerror = (e) => {
      console.error("[REX] script load failed", e);
      document.body.classList.remove("rex-defer");
      reject(e);
    };

    document.body.appendChild(s);
  });
}
